import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingBrokerOfferBookingActions {
  SetEnabled = 'newbuildingBrokerOfferBooking/setEnabled',
  SetCallbackWidgetOpened = 'newbuildingBrokerOfferBooking/setCallbackWidgetOpen',
}

export const setNewbuildingBrokerOfferBookingEnabled = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.SetEnabled,
  boolean
>(ENewbuildingBrokerOfferBookingActions.SetEnabled);

export const setNewbuildingBrokerCallbackWidgetOpened = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.SetCallbackWidgetOpened,
  boolean
>(ENewbuildingBrokerOfferBookingActions.SetCallbackWidgetOpened);

export type TNewbuildingBrokerOfferBookingActions =
  | ReturnType<typeof setNewbuildingBrokerOfferBookingEnabled>
  | ReturnType<typeof setNewbuildingBrokerCallbackWidgetOpened>;
